import CustomerMap from "@/views/customerMap/customerMap"

export default {
    path: '/customerMap',
    name: 'CustomerMap',
    component: CustomerMap,
  }


// WEBPACK FOOTER //
// ./src/router/customerMap/index.js